import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { ThirdpartyIntegrationType } from 'api/integrations';
import { TaskFormResponseChanged } from 'api/notifications/meta';
import { Avatar } from 'components/atoms/avatar';
import { RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';
import { InlineLink, Strong } from '../basics';
import { Causer } from './causer';

export const TaskFormResponseView: FC<{
  meta: TaskFormResponseChanged;
  projectId: number;
  formInstanceId?: number;
}> = ({
  meta: { by, isNewResponse, externalUser },
  projectId,
  formInstanceId = 0,
}) => {
  const { push } = useHistory();
  const open = useCallback(
    () =>
      push(
        RoutePaths.projectFormResponseByInstance
          .replace(':projectId', projectId.toString())
          .replace(':instanceId', formInstanceId.toString()),
      ),
    [push, projectId, formInstanceId],
  );

  const responseString = useTranslation('response');

  return (
    <FormattedMessage
      id={
        isNewResponse
          ? 'notifications.messages.task_form_response_added'
          : 'notifications.messages.task_form_response_updated'
      }
      values={{
        causer:
          externalUser?.integrationType === ThirdpartyIntegrationType.Form &&
          externalUser?.name ? (
            <>
              <Avatar size="small" name={externalUser?.name} />
              <Strong>{externalUser?.name}</Strong>
            </>
          ) : (
            <Causer user={by} />
          ),
        response: <InlineLink title={responseString} open={open} />,
      }}
    />
  );
};
